export default __webpack_public_path__ + "static/media/engagement4.6cca58f6.png";